import { actionTypes } from 'store/utils';

export const types = {
  SET_ACTIVE_FORM_ID: 'SET_ACTIVE_FORM_ID',
}